// This regular expression matches any Unicode space, newline, or punctuation
// character
export const SPACE_OR_PUNCTUATION = /[\n\r\p{Z}\p{P}]+/u;

export const OR = "or";
export const AND = "and";
export const AND_NOT = "and_not";
